import { ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit  } from '@angular/core';
import { AccountService } from './_services';
import { Subscription } from 'rxjs';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import * as actions from './courses/course-player/course-player.actions';
import * as fromCoursePlayer from './courses/course-player/course-player.reducer';
import { environment } from '../environments/environment';
import { MixpanelService } from '../app/_services/mixpanel.service';

declare let ga: Function;

@Component({ selector: 'app', templateUrl: 'app.component.html' })
export class AppComponent implements OnInit, OnDestroy {       
    subscription: Subscription;
    public loggedIn: boolean;
    public showFooter: boolean = true;
    public showHeader: boolean = true;
    public isHome: boolean = false;

    constructor(public auth: AccountService,
      private changeDetector: ChangeDetectorRef,
      private router: Router,
      private mixpanel: MixpanelService,
      private store: Store<{ coursePlayerState: fromCoursePlayer.State }>) {
        
        this.showHeader = true;
        this.showFooter = true;
        this.isHome = false;

        this.router.events.forEach((event) => {
          
          if (event instanceof NavigationStart) {
            this.changeDetector.detectChanges();
            if (event['url'].startsWith('/login')) {
              this.showHeader = false;
              this.showFooter = false;                      
            } else if (event['url'].startsWith('/latin-america-spanish-course')) {
              this.showHeader = false;
              this.showFooter = false;            
            }  else if (event['url'].startsWith('/account')) {
              this.showHeader = true;
              this.showFooter = true;            
            } else if (event['url'] === '/') {
              this.showHeader = true;
              this.showFooter = true;
              this.isHome = true;
            } else {
              this.showHeader = true;
              this.showFooter = true;            
              this.isHome = false;
            }
          } else if (event instanceof NavigationEnd && environment.production) {            
              ga('set', 'page', event.urlAfterRedirects);
              ga('send', 'pageview');            
          }
        });
      }

    async ngOnInit() {        

      this.mixpanel.init();

      this.subscription = this.auth.isAuthenticated()
      .subscribe(result => {
        this.loggedIn = result;                
      });      

      this.auth.loggedIn.subscribe(o => {
        console.log("logged in or out", { loggedIn: this.loggedIn, o: o})        

        this.changeDetector.detectChanges();
        this.loggedIn = o;
      });
    }

    ngOnDestroy() {
    }

    logout() {
      this.auth.signOut();
    }

    @HostListener('window:beforeunload', [ '$event' ])
      beforeUnloadHandler(event) {
        this.store.dispatch(new actions.Close());
      }
}